const {
  Business
} = require('../entities');

const AccessContext = require('./contexts/access-context');

const BusinessCategoriesRepo = require('./business-categories-repo');

class BusinessRepoHelper {
  constructor(client
  /*: ApiClient*/
  , context
  /*: AccessContext*/
  ) {
    this.client = client;
    this.context = context;
  } // TODO: Move this back into businesses-repo and delete this file


  getBusinessCategoriesStep(business
  /*: Business*/
  )
  /*: Promise<Business>*/
  {
    if (!business) return business;
    const categoriesRepo = new BusinessCategoriesRepo(this.client, this.context);
    return categoriesRepo.listAll().then(categories => {
      /* eslint-disable-next-line no-param-reassign */
      business.categories = categories.items;
      return business;
    });
  }

}

module.exports = BusinessRepoHelper;